document.addEventListener('DOMContentLoaded', function() {
  
  const carousels = document.querySelectorAll('.koji-hero-premium-carousel');
  
  carousels.forEach(carousel => {
    
    // FIX DOPPIO INNESCO: Impedisce che il codice si avvii due volte creando bug sulle barre e sui timer
    if (carousel.dataset.sliderInit === 'true') return;
    carousel.dataset.sliderInit = 'true';

    const innerWrapper = carousel.closest('.koji-hero-premium-inner');
    const slides = Array.from(carousel.querySelectorAll('.koji-hero-premium-slide'));
    const progressWrappers = Array.from(carousel.querySelectorAll('.koji-premium-progress-wrapper'));
    const prevBtn = carousel.querySelector('.koji-prev');
    const nextBtn = carousel.querySelector('.koji-next');
    
    const isAutoplay = carousel.getAttribute('data-autoplay') === 'true';
    const speed = parseInt(carousel.getAttribute('data-speed'), 10) || 6000;
    
    let currentIndex = 0;
    let autoplayTimer;
    let animFrameId;

    // INIZIALIZZAZIONE
    function init() {
      if (slides.length === 0) return;
      goToSlide(0);
      if (slides.length > 1) {
        setupSwipe();
      }
    }

    // FUNZIONE PRINCIPALE: CAMBIO SLIDE E SINCRONIZZAZIONE BARRA
    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      
      // Pulisci subito qualsiasi timer precedente per evitare accavallamenti
      clearTimeout(autoplayTimer);
      cancelAnimationFrame(animFrameId);
      
      // Gestione visibilità slide e bagliore
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('is-active');
          slide.removeAttribute('aria-hidden');
          
          const glowColor = slide.getAttribute('data-glow') || 'transparent';
          if (innerWrapper) {
            innerWrapper.style.setProperty('--active-glow', glowColor);
          }
        } else {
          slide.classList.remove('is-active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      currentIndex = index;

      // Gestione Barre di Progresso E Sincronizzazione Perfetta Mobile
      if (progressWrappers.length > 0) {
        progressWrappers.forEach((wrapper, i) => {
          const fill = wrapper.querySelector('.koji-premium-progress-fill');
          
          // Reset grafico istantaneo a zero per TUTTE le barre
          fill.style.transition = 'none';
          fill.style.width = '0%';
          wrapper.classList.remove('is-active');
          wrapper.setAttribute('aria-selected', 'false');

          // Anima SOLO quella attiva
          if (i === index) {
            wrapper.classList.add('is-active');
            wrapper.setAttribute('aria-selected', 'true');
            
            // FIX VISIVO MOBILE: Doppio requestAnimationFrame per forzare il rendering della barra allo 0% prima dell'animazione
            animFrameId = requestAnimationFrame(() => {
              animFrameId = requestAnimationFrame(() => {
                if (isAutoplay) {
                  fill.style.transition = `width ${speed}ms linear`;
                  fill.style.width = '100%';
                } else {
                  fill.style.transition = 'none';
                  fill.style.width = '100%';
                }
                
                // Avvia il conto alla rovescia reale per il cambio slide
                resetAutoplay();
              });
            });
          }
        });
      } else {
        resetAutoplay();
      }
    }

    // AUTOPLAY ENGINE
    function resetAutoplay() {
      clearTimeout(autoplayTimer);
      if (isAutoplay && slides.length > 1) {
        autoplayTimer = setTimeout(() => {
          goToSlide(currentIndex + 1);
        }, speed);
      }
    }

    // INTERAZIONI CLICK BOTTONI
    if (nextBtn) nextBtn.addEventListener('click', () => {
      goToSlide(currentIndex + 1);
    });
    
    if (prevBtn) prevBtn.addEventListener('click', () => {
      goToSlide(currentIndex - 1);
    });
    
    if (progressWrappers.length > 0) {
      progressWrappers.forEach((wrapper) => {
        wrapper.addEventListener('click', (e) => {
          const target = parseInt(e.currentTarget.getAttribute('data-target'), 10);
          goToSlide(target);
        });
      });
    }

    // GESTIONE SWIPE DA MOBILE (Scroll Protetto)
    function setupSwipe() {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;

      carousel.addEventListener('touchstart', e => {
        if (slides.length <= 1) return;
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      carousel.addEventListener('touchend', e => {
        if (slides.length <= 1) return;
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        handleSwipe();
      }, { passive: true });

      function handleSwipe() {
        const swipeThresholdX = 40; 
        const diffX = touchStartX - touchEndX;
        const diffY = touchStartY - touchEndY;

        // Scatta il cambio slide solo se il movimento è orizzontale e non verticale
        if (Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX > swipeThresholdX) {
            goToSlide(currentIndex + 1); 
          } else if (diffX < -swipeThresholdX) {
            goToSlide(currentIndex - 1); 
          }
        }
      }
    }

    // START!
    init();
  });
});